<template>
  <div id="app">
    <nav class="navbar navbar-expand-md navbar-dark fixed-top">
      <div class="container d-flex flex-md-row justify-content-between">
          <a href="/"><img src="static/img/logo.png" /></a>
          <a :href="decryptEmail('cmlja0ByaWNrc2VsbGVycy5kZXNpZ24=')"><img src="static/img/email-icon.png"  style="width: 16px; height: 16px;"/> Contact Me</a>
      </div>
    </nav>
    <router-view :key="$route.fullPath" />
    <div class="footer">
        <div class="container footer-menu">
            <quote-component></quote-component>
            <p class="copyright">© 2018-2026 Rick Sellers</p>
            <p class="tools">Built with Vue.</p>
        </div>
    </div>
  </div>
</template>

<script>
import QuoteComponent from './components/QuoteComponent'
export default {
  name: 'App',
  components: {
    QuoteComponent
  },
  data: () => {
    return {
    }
  },
  methods: {
    decryptEmail: function (address) {
      let temp = atob(address)
      return 'mailto: ' + temp
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue